import React from "react";
import CurrencyFormat from "react-currency-format";

const CustomCurrencyFormat = ({ value }) => {
  if (value === 0 || value === "0" || value === 0.0 || value === "0.0") {
    return "-";
  }

  return (
    <CurrencyFormat
      value={value}
      displayType={"text"}
      thousandSpacing={3}
      thousandSeparator={true}
      decimalScale={0}
    />
  );
};

export default CustomCurrencyFormat;